import { setCreateClip, deleteClip } from '@/services/clipApi'
import { setUserFunnel, getShareUrl } from '@/services/api'
import { copy } from '@/common/common'
import router from '../router'
import { isMobile } from '@/common/lib/strLib'
import store from '@/store'
import Toast from '@/views/meeting/component/Toast'

const clip = {
  state: () => ({
    // 클립 리스트 안에서의 Index
    clipIndex: null,
    // 섹션의 Index
    sectionIndex: null,
    // 클립 Title, Note 자동재생 시 저장을 위해 이전 섹션의 Index를 갖고있는다.
    // beforeSectionIndex: null,
    // 현재 재생중인 클립
    currentClip: null,
    // 강제로 player 를 정지 시킬때 (재생 중 녹화버튼 클릭 등)
    isPlayerForceStop: false,
    // 외부에서 Video Pause 설정 할 때
    isPlayerPause: null,
    // Video Player Pause 상태값 바뀌면서 아이콘을 바꿔줄 때
    isPauseIcon: null,
    // Video Player에서 현재 재생시간 구해올 때 SeekTime
    seekTime: null,
    //
    seekTimeDecimal: null,
    // Video Player에서 현재 재생시간 세팅할 때
    timeStampSeekTime: null,
    /**  같은 클립의 Player 에서 SeekTime 을 움직이기 위해 사용한다.
     * (CurrentClip, SectionIndex, ClipIndex 가 그대로이기 때문에 Computed 가 작동을 안해서..)
     * Todo : 다른 대안 있으면 알려주세요!!
     */
    isRequestSetSeekTime: false,
    // Player Volume
    volume: 100,
    // 영상의 길이
    duration: null,
    // 영상 재생배속
    playback: 1.25,
    // Seek가 되었을 때 영상의 시간
    seeked: 0,
    // 전체 섹션 및 클립 데이터
    totalSectionList: null,
    // 클립 정렬
    clipSort: null,
    // Player 전체화면 여부
    isFullScreen: null,
    // 편집중인 클립 저장
    editingClip: null,
    // 클립 업로드 후 데이터를 넣어주기 위한 temp Object
    uploadClip: null,
    // 클립 삭제 후 데이터를 넣어주기 위한 temp Object
    deleteClip: null,
    // 섹션 삭제 후 데이터를 편집하기 위한 temp Object
    deleteSection: null,
    // 섹션 추가 후 데이터를 편집하기 위한 temp Object
    addSection: null,
    // 업로드 후 mp4 변환 대기까지 임시로 blobData 로 화면을 보여준다.
    // Refresh 후 clip url이 들어오면 사용 안되는 데이터
    blobData: null,
    // 섹션의 마지막 클립일 경우 lastClip UI 를 보여준다.
    isLastClip: null,
    boxCommentList: null,
    // FollowUp 카드에서 녹화를 진행할 경우 ClipId 를 보내서 클립 업데이트를 할지 여부
    isReplaceFollowUp: null,
    // 재생중이 아닐 경우 Seek 시 재생되지 않도록 막기위한 변수
    isPauseSeek: false,
    isFeedback: false,
    // 업로드할 클립의 정보
    uploadVideoInfo: null,
    // Quick Record 여부 조회
    isQuickRecord: false,
    // 자막 데이터
    subTitleData: null,
  }),
  mutations: {
    setClipIndex(state, clipIndex) {
      state.clipIndex = clipIndex
    },
    setSectionIndex(state, sectionIndex) {
      state.sectionIndex = sectionIndex
    },
    // setBeforeSectionIndex(state, beforeSectionIndex) {
    //   state.beforeSectionIndex = beforeSectionIndex
    // },
    setCurrentClip(state, currentClip) {
      state.currentClip = currentClip
    },
    setIsPlayerForceStop(state, isPlayerForceStop) {
      state.isPlayerForceStop = isPlayerForceStop
    },
    setIsPlayerPause(state, isPlayerPause) {
      state.isPlayerPause = isPlayerPause
    },
    setIsPauseIcon(state, isPauseIcon) {
      state.isPauseIcon = isPauseIcon
    },
    setSeekTime(state, seekTime) {
      state.seekTime = seekTime
    },
    setSeekTimeDecimal(state, seekTime) {
      state.seekTime = seekTime
    },
    setTimeStampSeekTime(state, timeStampSeekTime) {
      state.timeStampSeekTime = timeStampSeekTime
    },
    setIsRequestSetSeekTime(state, isRequestSetSeekTime) {
      state.isRequestSetSeekTime = isRequestSetSeekTime
    },
    setVolume(state, volume) {
      state.volume = volume
    },
    setDuration(state, duration) {
      state.duration = duration
    },
    setPlayback(state, playback) {
      state.playback = playback
    },
    setSeeked(state, seeked) {
      state.seeked = seeked
    },
    setTotalSectionList(state, totalSectionList) {
      state.totalSectionList = totalSectionList
    },
    setClipSort(state, clipSort) {
      state.clipSort = clipSort
    },
    setIsFullScreen(state, isFullScreen) {
      state.isFullScreen = isFullScreen
    },
    setEditingClip(state, editingClip) {
      state.editingClip = editingClip
    },
    setUploadClip(state, uploadClip) {
      state.uploadClip = uploadClip
    },
    setDeleteClip(state, deleteClip) {
      state.deleteClip = deleteClip
    },
    setDeleteSection(state, deleteSection) {
      state.deleteSection = deleteSection
    },
    setAddSection(state, addSection) {
      state.addSection = addSection
    },
    setBlobData(state, blobData) {
      state.blobData = blobData
    },
    setIsLastClip(state, isLastClip) {
      state.isLastClip = isLastClip
    },
    setIsReplaceFollowUp(state, isReplaceFollowUp) {
      state.isReplaceFollowUp = isReplaceFollowUp
    },
    setIsPauseSeek(state, isPauseSeek) {
      state.isPauseSeek = isPauseSeek
    },
    setIsFeedback(state, isFeedback) {
      state.isFeedback = isFeedback
    },
    setUploadVideoInfo(state, uploadVideoInfo) {
      state.uploadVideoInfo = uploadVideoInfo
    },
    setIsQuickRecord(state, isQuickRecord) {
      state.isQuickRecord = isQuickRecord
    },
    setSubTitleData(state, subTitleData) {
      state.subTitleData = subTitleData
    },
  },
  actions: {
    setClipIndex({ commit }, clipIndex) {
      commit('setClipIndex', clipIndex)
    },
    setSectionIndex({ commit }, sectionIndex) {
      commit('setSectionIndex', sectionIndex)
    },
    setCurrentClip({ commit }, currentClip) {
      commit('setCurrentClip', currentClip)
    },
    setIsPlayerForceStop({ commit }, isPlayerForceStop) {
      commit('setIsPlayerForceStop', isPlayerForceStop)
    },
    setIsPlayerPause({ commit }, isPlayerPause) {
      commit('setIsPlayerPause', isPlayerPause)
    },
    setIsPauseIcon({ commit }, isPauseIcon) {
      commit('setIsPauseIcon', isPauseIcon)
    },
    setSeekTime({ commit }, seekTime) {
      commit('setSeekTime', seekTime)
    },
    setSeekTimeDecimal({ commit }, seekTime) {
      commit('setSeekTimeDecimal', seekTime)
    },
    setTimeStampSeekTime({ commit }, timeStampSeekTime) {
      commit('setTimeStampSeekTime', timeStampSeekTime)
    },
    setIsRequestSetSeekTime({ commit }, isRequestSetSeekTime) {
      commit('setIsRequestSetSeekTime', isRequestSetSeekTime)
    },
    setVolume({ commit }, volume) {
      commit('setVolume', volume)
    },
    setDuration({ commit }, duration) {
      commit('setDuration', duration)
    },
    setPlayback({ commit }, playback) {
      commit('setPlayback', playback)
    },
    setSeeked({ commit }, seeked) {
      commit('setSeeked', seeked)
    },
    setTotalSectionList({ commit }, totalSectionList) {
      commit('setTotalSectionList', totalSectionList)
    },
    setClipSort({ commit }, clipSort) {
      commit('setClipSort', clipSort)
    },
    setIsFullScreen({ commit }, isFullScreen) {
      commit('setIsFullScreen', isFullScreen)
    },
    setEditingClip({ commit }, editingClip) {
      commit('setEditingClip', editingClip)
    },
    setUploadClip({ commit }, uploadClip) {
      commit('setUploadClip', uploadClip)
    },
    setDeleteClip({ commit }, deleteClip) {
      commit('setDeleteClip', deleteClip)
    },
    setDeleteSection({ commit }, deleteSection) {
      commit('setDeleteSection', deleteSection)
    },
    setAddSection({ commit }, addSection) {
      commit('setAddSection', addSection)
    },
    setBlobData({ commit }, blobData) {
      commit('setBlobData', blobData)
    },
    setIsLastClip({ commit }, isLastClip) {
      commit('setIsLastClip', isLastClip)
    },
    setIsReplaceFollowUp({ commit }, isReplaceFollowUp) {
      commit('setIsReplaceFollowUp', isReplaceFollowUp)
    },
    setIsPauseSeek({ commit }, isPauseSeek) {
      commit('setIsPauseSeek', isPauseSeek)
    },
    setIsFeedback({ commit }, isFeedback) {
      commit('setIsFeedback', isFeedback)
    },
    setUploadVideoInfo({ commit }, uploadVideoInfo) {
      commit('setUploadVideoInfo', uploadVideoInfo)
    },
    setIsQuickRecord({ commit }, isQuickRecord) {
      commit('setIsQuickRecord', isQuickRecord)
    },
    setSubTitleData({ commit }, subTitleData) {
      commit('setSubTitleData', subTitleData)
    },
    clearClipData({ commit }) {
      commit('setClipIndex', null)
      commit('setSectionIndex', null)
      commit('setCurrentClip', null)
      commit('setIsPlayerPause', null)
      commit('setIsPauseIcon', null)
      commit('setSeekTime', null)
      commit('setTotalSectionList', null)
      commit('setIsFullScreen', null)
      commit('setEditingClip', null)
      // commit('setBeforeSectionIndex', null)
    },
    // 다음 영상으로 재생
    nextClip({ state, commit }, isEnded) {
      let clipIndex =
        state.clipIndex !== undefined && state.clipIndex !== null && state.clipIndex >= 0 ? Number(state.clipIndex) : 0
      let totalSectionList = state.totalSectionList
      let sectionIndex =
        state.sectionIndex !== undefined && state.sectionIndex !== null && state.sectionIndex >= 0
          ? Number(state.sectionIndex)
          : 0

      let clipList
      if (totalSectionList && sectionIndex <= totalSectionList.length - 1) {
        clipList = totalSectionList[sectionIndex].clipList

        // 재생할 클립이 남아있다면
        if (clipList !== undefined && clipIndex < clipList.length - 1) {
          let nextClip = clipList[clipIndex + 1]

          // 재생중이 아닐 경우는 멈춘상태로 실행
          if (!state.isPauseIcon && !isEnded) commit('setIsPauseSeek', true)

          commit('setClipIndex', clipIndex + 1)
          commit('setCurrentClip', nextClip)

          // 새로고침 후 스크롤 유지
          localStorage.setItem('currentClip', JSON.stringify(nextClip))
        } else if (clipList && clipIndex === clipList.length - 1 && !state.isLastClip) {
          // 마지막 클립을 UI를 호출한다.
          commit('setIsLastClip', true)
        }
        // 재생할 클립이 없으면 다음 섹션으로 이동
        else if (sectionIndex < totalSectionList.length - 1 && !state.isFullScreen) {
          let tempSectionIndex = sectionIndex + 1
          let startIndex = tempSectionIndex
          let nextClipList
          for (let i = startIndex; i <= totalSectionList.length - 1; i++) {
            nextClipList = totalSectionList[tempSectionIndex].clipList
            if (nextClipList !== undefined && nextClipList !== null && nextClipList.length > 0) break
            else tempSectionIndex = tempSectionIndex + 1
          }

          if (nextClipList !== undefined && nextClipList !== null && nextClipList.length > 0) {
            commit('setSectionIndex', tempSectionIndex)
            commit('setClipIndex', 0)
            commit('setCurrentClip', nextClipList[0])
            // 새로고침 후 스크롤 유지
            localStorage.setItem('currentClip', JSON.stringify(nextClipList[0]))
          }
        }
      }
    },
    // 이전 영상으로 재생
    beforeClip({ state, commit }) {
      let clipIndex =
        state.clipIndex !== undefined && state.clipIndex !== null && state.clipIndex >= 0 ? Number(state.clipIndex) : 0
      let totalSectionList = state.totalSectionList
      let sectionIndex =
        state.sectionIndex !== undefined && state.sectionIndex !== null && state.sectionIndex >= 0
          ? Number(state.sectionIndex)
          : 0

      if (!state.isLastClip) {
        // 이전 영상 재생할 것이 있으면 index 만 내려준다.
        if (clipIndex > 0) {
          // 재생중이 아닐 경우는 멈춘상태로 실행
          if (!state.isPauseIcon) commit('setIsPauseSeek', true)

          commit('setClipIndex', clipIndex - 1)
          let clipList = totalSectionList[sectionIndex].clipList
          commit('setCurrentClip', clipList[clipIndex - 1])
          localStorage.setItem('currentClip', JSON.stringify(clipList[clipIndex - 1]))
          // }
        }
        // 이전 영상이 없을 경우 이전 섹션이 있는지 체크한다.
        else {
          if (
            totalSectionList &&
            totalSectionList !== null &&
            sectionIndex > 0 &&
            sectionIndex <= totalSectionList.length - 1
          ) {
            let tempSectionIndex = sectionIndex - 1
            let clipList
            let startIndex = tempSectionIndex
            for (let i = startIndex; i >= 0; i--) {
              clipList = totalSectionList[tempSectionIndex].clipList
              if (clipList !== undefined && clipList !== null && clipList.length > 0) break
              else tempSectionIndex = tempSectionIndex - 1
            }
            if (clipList !== undefined && clipList !== null && clipList.length > 0) {
              let clipIndex = clipList.length - 1

              // 재생중이 아닐 경우는 멈춘상태로 실행
              if (!state.isPauseIcon) commit('setIsPauseSeek', true)
              commit('setClipIndex', clipIndex)
              commit('setCurrentClip', clipList[clipIndex])
              commit('setSectionIndex', tempSectionIndex)
              localStorage.setItem('currentClip', JSON.stringify(clipList[clipIndex]))
            }
          }
        }
      } else {
        commit('setIsLastClip', false)
      }
    },
    changeCurrentClip({ commit }, updateValue) {
      commit('setClipIndex', updateValue.clipIndex)
      commit('setSectionIndex', updateValue.sectionIndex)
      commit('setCurrentClip', updateValue.currentClip)
      commit('setTimeStampSeekTime', updateValue.timeStampSeekTime)
    },
    // 클립 생성 작업을 공통으로 빼냄
    async setCreateClip({ commit, dispatch, state }, params) {
      let stId = ''
      let wsId = ''
      let mtId = ''
      const selectedCh = this.getters.selectedCh
      const selectedWsInfo = this.getters.selectedWsInfo
      const currentMt = this.getters.currentMt
      let returnValue = {}
      if (params && params['stId']) {
        stId = params['stId']
        params['sectionTitle'] = undefined
      } else if (currentMt && currentMt.sectionInfo && currentMt.sectionInfo.length > 0) {
        stId = currentMt.sectionInfo[this.getters.sectionIndex ?? 0].stId
      }

      if (params && params['mtId']) mtId = params['mtId']
      else if (router.currentRoute.params['mtId']) mtId = router.currentRoute.params['mtId']

      let error
      let result
      try {
        let isTextClip = params['textClip'] && params['textClip'] !== ''
        let isEmbedClip = params['contentData']
        if (params['blob'] || isTextClip || isEmbedClip) {
          // this.progressValue = 0
          // this.uploadingSubTitle = UploadingState.Preparing
          let duration = !params['duration'] && isTextClip ? params['textClip'].length : params['duration']

          if (isTextClip) {
            let textDuration = duration / 25
            if (textDuration < 3) duration = 3
            else if (textDuration >= 7) duration = 7
            else duration = textDuration
          }

          wsId = currentMt && currentMt['wsId'] && currentMt['wsId'] !== '' ? currentMt['wsId'] : selectedWsInfo['wsId']

          let clipType = ''

          clipType = isEmbedClip ? params['contentData'].clipType : params['textClip'] ? 'text' : params['clipType']

          let blobUrl = ''
          let blobType = ''
          // BlobData 추가
          if (
            clipType &&
            params['blob'] &&
            (clipType === 'screen' || clipType === 'upload' || clipType === 'audio' || clipType === 'face')
          ) {
            blobUrl = URL.createObjectURL(params['blob'])
            blobType = params['blob'].type
          }
          // Todo : 클립 생성 api 나오면 연동하기
          result = await setCreateClip(
            this._vm,
            wsId,
            mtId,
            params['sectionTitle'] && params['sectionTitle'] !== '' ? params['sectionTitle'] : stId,
            state.isReplaceFollowUp ? state.currentClip.clipId : undefined,
            clipType,
            duration,
            params['clipNote'],
            this.getters.chkMtPublic['isPublic'] || this.getters.isMtCreator,
            params['textClip'],
            params['clipTitle'],
            state.isReplaceFollowUp,
            blobUrl,
            blobType,
            params['contentData'],
            params['emailNotiInfo'],
            params['transcriptStatus'],
            params['summaryStatus'],
            params['sttLanguage'],
            params['summaryTopics'],
            params['summaryTemplate'],
            params['audioSilenceList'],
            params['audioBlobs'] ? params['audioBlobs'].length : 0
          )
          // 클립을 업로드 후 workspace 의 총 클립 갯수를 새롭게 업데이트 시켜준다.
          store.dispatch('setWsClipCnt', {
            wsDomain: router.currentRoute.params['wsDomain'],
            userId: store.getters.userInfo ? store.getters.userInfo['userId'] : null,
          })

          // 전체 로딩을 없애주기 위해 sectionInfo를 받아오는 작업 추가
          commit('setUploadClip', result)
          commit('setDuration', result.clipDuration)
          localStorage.setItem('currentClip', JSON.stringify(result))

          // Funnel 체크
          dispatch('checkFunnel')

          // 클립 생성 GA Log 추가
          this.dispatch('setFirebaseLog', {
            eventName: 'create_clip',
            eventParam: {
              name: 'create_clip',
            },
          })

          // Side Bar 가 존재한다면.
          if (selectedWsInfo) {
            this.dispatch('getAssignedCnt', wsId)
            if (selectedCh && selectedCh['chId']) {
              this.dispatch('getChannelUpdate', {
                wsId: wsId,
                chId: selectedCh['chId'].includes('CH:') ? selectedCh['chId'] : `CH:${selectedCh['chId']}`,
                chType: selectedCh['chType'],
                chCategory: selectedCh['chCategory'],
              })
            }
          }
        } else {
          // notify(params['context'], 'Error', params['context'].$t('setClipFail'), 'error')

          const content = {
            component: Toast,
            props: {
              msg: params['context'].$t('setClipFail'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
      } catch (err) {
        error = err
        console.log('err ', err)
      } finally {
        // 클립 생성 성공 후 진행
        if (error === undefined || error === null) {
          // clipboard 에 url 복사
          dispatch('copyUrlToClipboard', {
            context: params['context'],
            clip: result,
          })
          // 텍스트 클립, contentData 가 있는 clip일 경우 s3 업로드 없이 진행
          if (params['textClip'] || params['contentData']) {
            // this.uploadFinish(true)
            returnValue = {
              type: 'uploadFinish',
              value: true,
            }
          }
          // 그 외의 경우 s3 에 업로드 진행
          else {
            // this.setThumbnailUpload(true)
            returnValue = {
              type: 'thumbnailUpload',
              clip: result,
              value: true,
            }
          }
        } else {
          // 클립 생성이 실패했으면 클립 삭제해주는 로직 추가
          if (result['clipId'] && result['clipId'] !== '') {
            try {
              await deleteClip(this, 'CLIP', wsId, mtId, result['clipId'])
            } catch (error) {
              console.log()
            } finally {
              result = {}
            }
          }
          // this.$emit('finish', false)
          // this.uploadFinish(false)
          returnValue = {
            type: 'uploadFinish',
            value: false,
          }
          // notify(params['context'], 'Error', params['context'].$t('setClipFail'), 'error')

          const content = {
            component: Toast,
            props: {
              msg: params['context'].$t('setClipFail'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
      }

      return new Promise((resolve) => {
        resolve(returnValue)
      })
    },
    async checkFunnel() {
      try {
        const funnel = this.getters.userInfo.funnel
        const funnelUpdatedAt = this.getters.userInfo.funnelUpdatedAt
        const dateGap = funnelUpdatedAt && funnelUpdatedAt !== null ? Date.now() - funnelUpdatedAt : 0
        const isTrigger = 1000 * 60 * 60 * 24 <= dateGap
        if (isTrigger && funnel && funnel !== '' && funnel === 'beginner') {
          let result = await setUserFunnel(this, 'regular')
          this.commit('setUserInfo', result)
          this.dispatch('setFirebaseLog', {
            eventName: 'funnel_regular',
            eventParam: {
              createdAt: Date.now(),
              methodType: 'create_clip',
            },
          })
        }
      } catch (e) {
        console.log()
      }
    },

    // 클립 생성 시 자동으로 clipboard에 start from clip url 복사
    async copyUrlToClipboard({ dispatch }, params) {
      let context = params['context']
      let clip = params['clip']
      let shareUrl = await dispatch('createShareUrl', { payload: clip })
      let copyResult = await copy(shareUrl)

      if (copyResult) {
        if (!isMobile()) {
          // notify(context, 'Success', context.$t('copiedClipboardUrl'), 'success')

          const content = {
            component: Toast,
            props: {
              msg: context.$t('copiedClipboardUrl'),
              // submsg: '',
            },
          }
          context.$toast.success(content)
        }
      } else {
        // const content = {
        //   component: Toast,
        //   props: {
        //     msg: context.$t('failedCopy'),
        //     // submsg: '',
        //   },
        // }
        // context.$toast.error(content)
        console.log('Failed to copy URL')
      }
      // else notify(this, 'Error', this.$t('failedCopy'), 'error')
    },
    async createShareUrl(context, { payload }) {
      let clip = payload
      let currentMt = this.getters.currentMt
      let title = currentMt.mtTopic
      let imgUrl = currentMt.mtThumbsUrl
      let routePayload = {
        name: 'ChannelMeetingShare',
        params: {
          wsDomain: router.currentRoute.params['wsDomain'],
          chId: this.selectedCh && this.selectedCh['chId'] ? this.selectedCh['chId'].replace('CH:', '') : '',
          mtId: router.currentRoute.params['mtId'],
        },
      }

      // console.log('routePayload', routePayload)
      let linkUrl = location.origin + router.resolve(routePayload).href
      let content = ''

      if (clip) {
        const path = 'https://file.tape.ooo/clip/'
        content = clip['clipNote']
        if (clip['clipThumbsUrl']) imgUrl = clip['clipThumbsUrl']
        else imgUrl = `${path}${clip['clipId']}.webp`
        linkUrl += '?clipId=' + clip['clipId']
      }

      // 공유 URL 생성 // TODO: fallbackUrl은 나중에 추가
      let copyUrl = await getShareUrl(this._vm, title, content, imgUrl, linkUrl)
      return copyUrl.shortLink
    },
  },
  getters: {
    clipIndex(state) {
      return state.clipIndex
    },
    sectionIndex(state) {
      return state.sectionIndex
    },
    // beforeSectionIndex(state) {
    //   return state.beforeSectionIndex
    // },
    currentClip(state) {
      return state.currentClip ? state.currentClip : {}
    },
    isPlayerForceStop(state) {
      return state.isPlayerForceStop
    },
    isPlayerPause(state) {
      return state.isPlayerPause
    },
    isPauseIcon(state) {
      return state.isPauseIcon
    },
    seekTime(state) {
      return state.seekTime !== undefined && state.seekTime !== null ? Math.floor(state.seekTime) : 0
    },
    seekTimeDecimal(state) {
      return state.seekTime !== undefined && state.seekTime !== null ? state.seekTime : 0
    },
    timeStampSeekTime(state) {
      return state.timeStampSeekTime !== undefined && state.timeStampSeekTime !== null ? state.timeStampSeekTime : 0
    },
    isRequestSetSeekTime(state) {
      return state.isRequestSetSeekTime
    },
    volume(state) {
      return state.volume
    },
    duration(state) {
      return state.duration
    },
    playback(state) {
      return state.playback
    },
    seeked(state) {
      return state.seeked
    },
    totalSectionList(state) {
      return state.totalSectionList
    },
    clipSort(state) {
      return state.clipSort !== undefined && state.clipSort !== null ? state.clipSort : 'Latest'
    },
    isFullScreen(state) {
      return state.isFullScreen
    },
    editingClip(state) {
      return state.editingClip
    },
    uploadClip(state) {
      return state.uploadClip
    },
    deleteClip(state) {
      return state.deleteClip
    },
    deleteSection(state) {
      return state.deleteSection
    },
    addSection(state) {
      return state.addSection
    },
    blobData(state) {
      return state.blobData
    },
    isLastClip(state) {
      return state.isLastClip
    },
    isReplaceFollowUp(state) {
      return state.isReplaceFollowUp
    },
    isPauseSeek(state) {
      return state.isPauseSeek
    },
    isFeedback(state) {
      return state.isFeedback
    },
    uploadVideoInfo(state) {
      return state.uploadVideoInfo
    },
    isQuickRecord(state) {
      return state.isQuickRecord
    },
    subTitleData(state) {
      return state.subTitleData
    },
    clipList(state) {
      let totalSectionList = state.totalSectionList
      let sectionIndex = state.sectionIndex
      if (
        totalSectionList !== undefined &&
        totalSectionList !== null &&
        totalSectionList.length > 0 &&
        state.sectionIndex !== undefined &&
        state.sectionIndex !== null &&
        state.sectionIndex >= 0
      ) {
        return totalSectionList[sectionIndex] ? totalSectionList[sectionIndex].clipList : []
      }
      return []
    },
  },
}

export default clip
